import { ComponentProps, FC } from 'react'
import styled from 'styled-components'

import useIsDescendantOfMap from 'hooks/useIsDescendantOfMap'

type MediaWrapperOptions = {
  portrait?: boolean
  rounded?: boolean
}

const MediaWrapper = styled.div<MediaWrapperOptions>`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 0;

  /* css way of maintaining aspect ratio with reference to width */
  padding-top: ${({ portrait }) => (portrait ? '125%' : '72.222%')};

  ${({ rounded = true }) =>
    rounded &&
    `
    border-radius: 6px;
  `}

  background-color: #ddd;

  transform: translate3d(0, 0, 0);
`

export const MediaWrapperOrientated: FC<
  ComponentProps<typeof MediaWrapper> & { portrait?: boolean }
> = ({ children, portrait: portraitProp, ...props }) => {
  const isDescendantOfMap = useIsDescendantOfMap()

  const portrait = portraitProp === true && isDescendantOfMap !== true

  return (
    <MediaWrapper portrait={portrait} {...props}>
      {children}
    </MediaWrapper>
  )
}

export default MediaWrapper
